function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera || window.chrome;
  
    var browserType="";
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 )
      {
          browserType='Opera';
      }
      else if(navigator.userAgent.indexOf("Chrome") != -1 )
      {
          browserType='Chrome';
      }
      else if(navigator.userAgent.indexOf("Safari") != -1)
      {
          browserType='Safari';
      }
      else if(navigator.userAgent.indexOf("Firefox") != -1 )
      {
           browserType='Firefox';
      }
      else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
      {
        browserType='IE';
      }
      else
      {
         browserType='unknown';
      }
  
   // var agentText=navigator.appCodeName+"-"+navigator.appVersion+"-"+navigator.platform;
  
   var agentText=navigator.sayswho+"-"+navigator.platform;
  
     if (/Windows/i.test(userAgent)) {
          return "WEB-"+agentText;
      }
        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "MOB-"+agentText;;
      }
  
      if (/android/i.test(userAgent)) {
       return "MOB-"+agentText;;
      }
  
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "MOB-"+agentText;;
      }
  
  
      return "unknown-"+agentText;
}

export default getMobileOperatingSystem;